export const GET_STARTED_STRINGS = {
  title:
    'Your new Belong home\nis\u00a0only\u00a0a\u00a0few\u00a0steps\u00a0away.',
  hot_home_tag: '🔥 Hot home!',
  benefits: {
    title: 'As a Belong resident, you’ll\u00a0enjoy...',
    standards:
      'Receive consistent, quality care with Belong’s Open\u00a0Standards.',
    stress_free:
      'A stress-free experience, with your very own Concierge, and\u00a024/7\u00a0Support.',
    belong_app:
      'Manage your home from the Belong App, with 30k+ Pros at your\u00a0fingertips.',
  },
  key_factors: {
    title:
      'While we believe everyone should get to live in a Belong home, these key factors are used to approve\u00a0applications.',
    items: [
      {
        title: 'Steady Income',
        body: "As part of this application, you'll be asked to verify your income. Combined income should be at least 3x monthly rent to cover rent and life's\u00a0expenses.",
        icon: '/residents/application-key-factor-steady-income.svg',
      },
      {
        title: 'Credit',
        body: "Credit scores matter, but they're not everything. Belong requires a 700+ score, though lower scores may be considered with a higher security\u00a0deposit.",
        icon: '/residents/application-key-factor-credit.svg',
      },
      {
        title: 'Background Checks',
        body: 'We check public records and require a history free of evictions, bankruptcies, multiple late payments, and criminal records (where\u00a0allowed).',
        icon: '/residents/application-key-factor-background-checks.svg',
      },
      {
        title: 'References',
        body: 'Belong requires a positive reference from your last landlord. We’ll ask for their contact information at the end of your\u00a0application.',
        icon: '/residents/application-key-factor-references.svg',
      },
    ],
    credit: {
      title: 'Credit Requirements',
      subtitle:
        "We typically look for the following in an applicant's credit\u00a0history.",
      bulletPoints: [
        '2+ Years Of Credit History ',
        '2+ Open Accounts',
        'Credit Utilization At Or Below 35%',
        'No Current Delinquent Accounts',
        'No Severe Delinquencies (Bankruptcies, Charge-Offs, Payments More Than 90 Days Late, etc.)',
        'No Late Payments In The Last 12 Months',
        'No More Than 5 Late Payments In The Last 36 Months',
        'Debt to income ratio less than 43%',
      ],
      openModal: 'Learn More',
      closeModal: 'Got it!',
    },
  },
  existing_applications: {
    title_one: 'Looks like you have an existing application...',
    title_multiple: 'Looks like you have some existing applications...',
    created_on: 'Created On {date}',
    apply_with: 'Applied With',
  },
  resume_application_button: 'RESUME APPLICATION',
  use_existing_application_button: 'Use Existing Application',
  continue_existing_application_button: 'Continue Application',
  start_new_application_button: 'Start New Application',
  tip: {
    description:
      'I have the honor of finding someone to love this home. Could that be you? This application will only take a few minutes. Please make sure all residents over the age of 18 complete an application.',
  },
};
